<template>
  <div class="title">
    {{$i18n.translate(title)}}
  </div>
</template>

<script>
export default {
  name: "cardTitle",
  props: ['title'],
}
</script>

<style scoped>
</style>
